import React from "react";
import Layout from "../../components/layout/index";

import Hero from "../../components/justaskvi/Hero";
import HowItWorks from "../../components/justaskvi/HowItWorks";
import WhatYouGet from "../../components/justaskvi/WhatYouGet";
import Pricing from "../../components/justaskvi/PricingCard";
import PageContainer from "../../components/PageContainer";

const JustAskViProduct = () => {
  return (
    <PageContainer
    title="Just Ask VI: Buy Indian Private Company Financials Per Company | Venture Intelligence"
    description="Get the latest financial statements (P&L, Balance Sheet, Cash Flow) in Excel and annual reports of Indian private companies. ₹600 + GST per company, instant download, no subscription."
    >
      <Layout>
        <Hero />
        <HowItWorks />
        <WhatYouGet />
        <Pricing />
      </Layout>
    </PageContainer>
  );
};

export default JustAskViProduct;
